import React from 'react';
import { useDrag } from 'react-dnd';
import '../../Potemplate.css';
import PurchaseOrderDetail from '../PurchaseOrderDetail';

function PurchaseOrderRecivingEndDetail({ data, i, fromForm, onChangeForData, setShowUpload }) {
  const [{ itemDragging }] = useDrag({
    type: 'container',
    collect: (monitor) => ({
      itemDragging: monitor.getItem(),
    }),
  });

  return (
    itemDragging?.type !== 'container' && (
      <PurchaseOrderDetail data={data} i={i} fromForm={fromForm} onChangeForData={onChangeForData} setShowUpload={setShowUpload} />
    )
  );
}

export default PurchaseOrderRecivingEndDetail;
